import { takeLatest, put, call } from 'redux-saga/effects';
import {
  fetchMsrHomes,
  appNotify,
  setSelectedOpportunityMsrHomes,
  setIsFetchingMsrHomes
} from 'store/actions';
import { getWithToken } from 'api/network';

export function* getMsrHomesSaga() {
  yield takeLatest(fetchMsrHomes, function* ({ payload: taskId }) {
    try {
      yield call(getMsrHomes, taskId);
      yield put(setIsFetchingMsrHomes(false));
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setIsFetchingMsrHomes(false));
    }
  });
}

export function* getMsrHomes(taskId) {
  let msrHomesDto = null;
  try {
     const msrHomesResponse = yield getWithToken(`/api/underwrite/prop/${taskId}/msrHomes`)
     msrHomesDto = yield msrHomesResponse.json();
     yield put(setSelectedOpportunityMsrHomes(msrHomesDto));
  } catch (error) {
    yield put(appNotify(error.message, 'error'));
  }
  return msrHomesDto;
}